









































































































import { Component, Vue } from 'vue-property-decorator';

import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';

import { uuid } from 'vue-uuid';

import APIService from '../services/api';
import { IEvent } from '../shared/services/models/Event';

// The @Component decorator indicates the class is a Vue component
@Component({
    components: {
        // @ts-ignore
        CopyrightComponent : require('@/components/Copyright').default,
    },
    computed: {
        ...mapState(['newEvents', 'eventCount']),
    },
    methods: {
    },
})
export default class EventsComponent extends Vue {
    private newEvents!: IEvent[];
    private eventCount!: number;
    private events: IEvent[] = [];
    private updateHandle: number = 0;
    private lastEventTimestamp: string|undefined;
    private page: number = 1;
    private perPage: number = 100;

    private mounted() {
        this.getEventPage(0);

        // @ts-ignore
        this.updateHandle = setInterval(() => {
            if (this.newEvents && this.newEvents.length > 0) {
                this.newEvents.forEach((e) => {
                    if (this.page === 0 && this.events.filter((e2) => e2.id === e.id).length === 0) {
                        if (!this.lastEventTimestamp) {
                            this.events.push(e);
                            this.lastEventTimestamp = e.timestamp;
                        } else if ((new Date(this.lastEventTimestamp)) < (new Date(e.timestamp)) ) {
                            this.events.push(e);
                            this.lastEventTimestamp = e.timestamp;
                        }
                    }
                });
            }
        }, 1000);
    }

    private get UserEvents(): IEvent[] {
        const ret: IEvent[] = [];
        // tslint:disable-next-line:prefer-for-of
        for (let i: number = 0; i < this.events.length; i++) {
            const e = this.events[i];

            switch (e.type) {
                case 'start requested':
                case 'stop requested':
                case 'restart requested':
                case 'save requested': ret.push(e); break;
                default: break;
            }
        }

        return ret;
    }

    private get Events(): IEvent[] {
        return this.events.sort((l: IEvent, r: IEvent) => {
                            if (l.timestamp > r.timestamp) {
                                return -1;
                            } else if (l.timestamp < r.timestamp) {
                                return 1;
                            }
                            return 0;
                        });
    }

    private getEventPage(page: number) {
        APIService.GetEvents(undefined, page).then((data) => {
            this.events = data;
        }).catch((err: any) => {
            // tslint:disable-next-line:no-console
            console.log('Error gettings events', err);
        });
    }

    private nextPage() {
        this.page++;
        this.getEventPage(this.page);
    }

    private previousPage() {
        this.page--;
        this.getEventPage(this.page);
    }

    private pageChanges(page: number) {
        this.getEventPage(page - 1);
    }

    private destroyed() {
        clearInterval(this.updateHandle);
    }
}
